<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <graph-tool-bar :dateRangeMenu="false" @on-selected="onPanelSelect">
        <template slot="appliancesMenu">
          <appliances-menu @on-selected="applianceSelect"></appliances-menu>
        </template>
      </graph-tool-bar>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <highcharts class="charts" :options="timesChartOptions" ref="timesChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <highcharts class="charts" :options="durationChartOptions" ref="durationChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <highcharts class="charts" :options="dayChartOptions" ref="dayChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <highcharts class="charts" :options="weekChartOptions" ref="weekChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <highcharts class="charts" :options="monthChartOptions" ref="monthChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-content>
          <highcharts class="charts" :options="yearChartOptions" ref="yearChart"></highcharts>
        </md-card-content>
      </md-card>
    </div>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>


<script>
import appliancesMenu from "./components/AppliancesMenu";
import graphToolBar from "@/components/GraphToolBar";
import snackBar from "@/components/SnackBar";

import axios from "axios";
import { getSelectedDeviceToken } from "@/storage/memoryStorage";
import areaChartOptions from "@/config/charts/area";

export default {
  components: {
    "graph-tool-bar": graphToolBar,
    "snack-bar": snackBar,
    appliancesMenu
  },
  data() {
    return {
      chartOptions: null,
      toolBarData: null,
      appliancesData: null,

      timesChartOptions: {},
      durationChartOptions: {},
      dayChartOptions: {},
      weekChartOptions: {},
      monthChartOptions: {},
      yearChartOptions: {}
    };
  },

  created() {
    this.chartOptions = {
      time: {
        useUTC: true
      },
      chart: {
        type: "scatter",
        zoomType: "x"
      },
      title: {
        text: ""
      },
      xAxis: {
        type: "datetime",
        title: {
          enabled: true,
          text: "Time"
        },
        startOnTick: true,
        endOnTick: true,
        showLastLabel: true
      },
      yAxis: {
        min: 0,
        max: 0,
        tickInterval: 1,
        title: {
          text: ""
        },
        labels: {
          enabled: false
        }
      },
      legend: {
        verticalAlign: "top"
      },
      plotOptions: {
        scatter: {
          marker: {
            radius: 5,
            states: {
              hover: {
                enabled: true,
                lineColor: "rgb(100,100,100)"
              }
            }
          },
          states: {
            hover: {
              marker: {
                enabled: false
              }
            }
          }
        }
      },
      tooltip: {
        style: {
          whiteSpace: "nowrap",
          fontSize: "14px"
        },
        pointFormat:
          "<span style='color:{point.color}'>●</span> {series.name}<br/>",
        headerFormat: "<span style='font-size: 12px'>{point.key}</span><br/>"
      },

      series: [
        {
          name: "Normal",
          data: []
        },
        {
          name: "Anomaly",
          data: []
        }
      ],

      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            menuItems: [
              "viewFullscreen",
              "printChart",
              "separator",
              "downloadCSV",
              "downloadXLS",
              "downloadPNG",
              "downloadPDF",
              "viewData"
            ]
          }
        }
      },
      credits: {
        enabled: false
      },
      colors: [
        "#00bcd4",
        "#f44336",
        "#4caf50",
        "#ff9800",
        "#fb4579",
        "#9761c8",
        "#4b63ec",
        "#fb636a",
        "#206692",
        "#668891"
      ],
      legend: {
        verticalAlign: "top"
      },
      lang: {
        decimalPoint: "."
      },
      navigator: {
        enabled: false
      },
      pane: {
        background: []
      },
      rangeSelector: {
        enabled: false
      },
      responsive: {
        rules: []
      },
      scrollbar: {
        enabled: true,
        liveRedraw: true,
        showFull: false
      },
      noData: {
        useHTML: true
      },
      plotOptions: {
        series: {
          animation: false
        }
      },
      chartarea: {},
      plotarea: {}
    };

    this.timesChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
    this.timesChartOptions.title.text = "";
    this.timesChartOptions.yAxis.title.text = "";
    this.timesChartOptions.xAxis.title.text = "Time";
    //this.timesChartOptions.xAxis.type = "linear";
    this.timesChartOptions.xAxis.min = 0;
    //this.timesChartOptions.xAxis.max = 86400000;

    this.timesChartOptions.xAxis.dateTimeLabelFormats = {
      day: "00:00"
    };

    this.timesChartOptions.tooltip.dateTimeLabelFormats = {
      day: "%H:%M:%S"
    };

    this.timesChartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.durationChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
    this.durationChartOptions.title.text = "";
    this.durationChartOptions.yAxis.title.text = "";
    this.durationChartOptions.xAxis.title.text = "";
    //this.durationChartOptions.xAxis.type = "linear";
    this.durationChartOptions.xAxis.min = 0;
    //this.durationChartOptions.xAxis.max = 86400000;

    this.durationChartOptions.xAxis.dateTimeLabelFormats = {
      day: "00:00"
    };

    this.durationChartOptions.tooltip.dateTimeLabelFormats = {
      day: "%H:%M:%S"
    };

    this.durationChartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.dayChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
    this.dayChartOptions.title.text = "";
    this.dayChartOptions.yAxis.title.text = "";
    this.dayChartOptions.xAxis.min = 0;
    this.dayChartOptions.xAxis.max = 86400000;

    this.dayChartOptions.xAxis.dateTimeLabelFormats = {
      day: "00:00"
    };

    this.dayChartOptions.tooltip.dateTimeLabelFormats = {
      day: "%H:%M:%S"
    };

    this.dayChartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.weekChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
    this.weekChartOptions.title.text = "";
    this.weekChartOptions.yAxis.title.text = "";

    this.weekChartOptions.xAxis.min = 0;
    this.weekChartOptions.xAxis.max = 604800000;
    this.weekChartOptions.xAxis.dateTimeLabelFormats = {
      day: "%e. day"
    };

    this.weekChartOptions.tooltip.dateTimeLabelFormats = {
      day: "%e. day %H:%M:%S"
    };

    this.weekChartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.monthChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
    this.monthChartOptions.title.text = "";
    this.monthChartOptions.yAxis.title.text = "";

    this.monthChartOptions.xAxis.min = 0;
    this.monthChartOptions.xAxis.max = 2678400000;
    this.monthChartOptions.xAxis.dateTimeLabelFormats = {
      day: "%e. day"
    };

    this.monthChartOptions.tooltip.dateTimeLabelFormats = {
      day: "%e. day %H:%M:%S"
    };

    this.monthChartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };

    this.yearChartOptions = JSON.parse(JSON.stringify(this.chartOptions));
    this.yearChartOptions.title.text = "";
    this.yearChartOptions.yAxis.title.text = "";

    this.yearChartOptions.xAxis.min = 0;
    this.yearChartOptions.xAxis.max = 31536000000;
    this.yearChartOptions.xAxis.dateTimeLabelFormats = {
      day: "%e.%b",
      month: "%B"
    };

    this.yearChartOptions.tooltip.dateTimeLabelFormats = {
      day: "%e.%b %H:%M:%S"
    };

    this.yearChartOptions.chart.events = {
      redraw: function(event) {
        this.hideLoading();
      }
    };
  },

  methods: {
    applianceSelect(data) {
      const timesChart = this.$refs.timesChart.chart;
      timesChart.setTitle({text: this.$lang.charts.runrun_anomaly_title + " " + data.title}, false, false);

      const durationChart = this.$refs.durationChart.chart;
      durationChart.setTitle({text: this.$lang.charts.duration_anomaly_title + " " + data.title}, false, false);

      const dayChart = this.$refs.dayChart.chart;
      dayChart.setTitle({text: this.$lang.charts.day_anomaly_title + " " + data.title}, false, false);

      const weekChart = this.$refs.weekChart.chart;
      weekChart.setTitle({text: this.$lang.charts.week_anomaly_title + " " + data.title}, false, false);

      const monthChart = this.$refs.monthChart.chart;
      monthChart.setTitle({text: this.$lang.charts.month_anomaly_title + " " + data.title}, false, false);

      const yearChart= this.$refs.yearChart.chart;
      yearChart.setTitle({text: this.$lang.charts.year_anomaly_title + " " + data.title}, false, false);

      this.$nextTick(() => {
        this.getAPIData(this.toolBarData.device, data.data.ID_appliance);
      });
    },

    onPanelSelect(data) {
      this.toolBarData = data;
    },

    getAPIData(selectedDevice, ID_appliance) {
      const timesChart = this.$refs.timesChart.chart;
      timesChart.showLoading();

      const durationChart = this.$refs.durationChart.chart;
      durationChart.showLoading();

      const dayChart = this.$refs.dayChart.chart;
      dayChart.showLoading();

      const weekChart = this.$refs.weekChart.chart;
      weekChart.showLoading();

      const monthChart = this.$refs.monthChart.chart;
      monthChart.showLoading();

      const yearChart = this.$refs.yearChart.chart;
      yearChart.showLoading();

      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/nilm/anomaly-charts",
        data: {
          device_token: getSelectedDeviceToken(selectedDevice.mac),
          ID_appliance: Number(ID_appliance)
        },
        withCredentials: true
      })
        .then(response => {
          this.setChartData(
            timesChart,
            response.data.data.timesClass,
            response.data.data.times
          );
          this.setChartData(
            durationChart,
            response.data.data.durationsClass,
            response.data.data.durations
          );
          this.setChartData(
            dayChart,
            response.data.data.timeOfDayClass,
            response.data.data.timeOfDay
          );
          this.setChartData(
            weekChart,
            response.data.data.timeOfWeekClass,
            response.data.data.timeOfWeek
          );
          this.setChartData(
            monthChart,
            response.data.data.timeOfMonthClass,
            response.data.data.timeOfMonth
          );
          this.setChartData(
            yearChart,
            response.data.data.timeOfYearClass,
            response.data.data.timeOfYear
          );
        })
        .catch(error => {
          if (error.response.data.code == 610) {
            this.$refs.snackbar.notify(this.$lang.messages.data_not_found);
          } else {
            this.$refs.snackbar.notify(
              this.$lang.messages.api_communication_error
            );
          }
        });
    },

    setChartData(chartRef, dataClass, timestamps) {
      let normalData = [];
      let anomalyData = [];

      if (dataClass && timestamps) {
        const arrayLength = timestamps.length;
        for (let index = 0; index < arrayLength; index++) {
          if (dataClass[index] == 1) {
            normalData.push([timestamps[index] * 1000, 0]);
          } else {
            anomalyData.push([timestamps[index] * 1000, 0]);
          }
        }
      }

      chartRef.series[0].setData(normalData, false, false, false);
      chartRef.series[1].setData(anomalyData, false, false, false);

      chartRef.xAxis[0].setExtremes(null, null, true);
    }
  }
};
</script>

<style lang="scss" scoped>
.md-toolbar {
  position: inherit;
}

.charts {
  min-height: 250px;
  height: 250px;
}
</style>